import {getIntents} from '../intent';
import {onRender} from '../deprecated/intentTypes';
import {runTokenIntents} from '../token';
import {Priority} from './constants';
import {runElementTransforms} from './element';
import {addIntentsToRevision} from './ViewRevision';
import type {View} from './types';
import {runLazyStyleIntents} from '../style/StyleIntent';
import type {CssPolicy} from '../providers/EngineConfigProvider';

export function runDomIntents<
  Props,
  Options extends View.ConfigOptions = never,
>(
  revision: View.ViewRevision<Props>,
  options: Options,
  cssPolicy?: CssPolicy,
): void {
  if (process.env.NODE_ENV !== 'production') {
    const onRenders = getIntents(onRender, revision);
    if (onRenders) {
      throw new Error(
        '`onRender` intents are not supported on this view. Use `dynamic` intents instead.',
      );
    }
  }

  addIntentsToRevision(
    revision,
    runTokenIntents(revision, cssPolicy),
    Priority.Normal,
  );

  runElementTransforms(revision);
  runLazyStyleIntents(revision, options, cssPolicy);
}
